/* eslint-disable */
import { getWidget, sendCollectedFeedback } from "api";
import { isEmpty, omit } from "lodash";
import Cookies from "js-cookie";
import types from "./types/types";
import { generateFinalPage } from "utils/helperFunctions";
import { appParamater, setAppParameter } from "utils/appDesign";

export const selectLanguage = (data) => (dispatch) => {
  dispatch({
    type: types.SELECT_LANGUAGE,
    data,
  });
  dispatch(nextPage());
};

export const setSessionId = (data, lang) => ({
  type: types.SET_SESSION_ID,
  data,
  lang,
});

export const setRateParam = (data) => ({
  type: types.SET_RATE_PARAM,
  data,
});

export const nextPage = () => (dispatch, getState) => {
  const { currentPage, maxPage, isFinal } = getState();
  if (currentPage < maxPage && !isFinal) {
    dispatch(handleNextPage());
  }
};

export const handleNextPage = (data) => (dispatch) => {
  dispatch(updateCondition());
  dispatch({
    type: types.NEXT_PAGE,
    data,
  });
  dispatch(generatePageComponents());
};

export const previousPage = () => (dispatch) => {
  dispatch({
    type: types.PREVIOUS_PAGE,
  });
  dispatch(generatePageComponents());
};

export const generatePageComponents = (data) => ({
  type: types.GENERATE_PAGE_COMPONENTS,
  data,
});

export const saveFormValues = (data) => (dispatch, getState) => {
  dispatch({
    type: types.SAVE_FORM_VALUES,
    data,
  });
  dispatch(nextPage());
};

export const fetchWidgetJSON = (uid) => (dispatch) => {
  dispatch(fetchWidgetJSONStarted());
  //My changes
  // dispatch(fetchWidgetJSONSuccess(newJSON))
  getWidget(uid)
    .then((res) => {
      const { data } = res || {};
      if (!isEmpty(data)) {
        setAppParameter(data.general_settings.company);
        dispatch(
          fetchWidgetJSONSuccess({
            uid,
            data: res.data,
          })
        );
        dispatch(generatePageComponents());
      } else {
        dispatch(setIsErrorPage());
      }
    })
    .catch((err) => {
      dispatch(fetchWidgetJSONFailure());
    });
};

const setIsErrorPage = () => ({
  type: types.SET_IS_ERROR_PAGE,
});
const fetchWidgetJSONStarted = () => ({
  type: types.FETCH_WIDGET_JSON_STARTED,
});

const fetchWidgetJSONSuccess = (data) => ({
  type: types.FETCH_WIDGET_JSON_SUCCESS,
  data,
});

const fetchWidgetJSONFailure = (data) => ({
  type: types.FETCH_WIDGET_JSON_FAILURE,
  data,
});

export const selectRate = (data) => (dispatch, getState) => {
  const { serviceId, option } = data;
  const { name: rate } = option || {};
  const { markpage_data } = getState().widgetJSON.data;
  const { pageComponents, feedbackArray } = getState() || {};
  if (
    option.markpage_idx
    // !feedbackArray.some(
    //   (feeedback) =>
    //     feeedback.serviceId === serviceId && feeedback.rate === rate
    // )
  ) {
    //My changes
    const markpage = markpage_data.find(
      (item) => item.idx === option.markpage_idx
    ); //
    dispatch(
      showMarkpage({
        serviceId,
        markpage,
        rate: option.name,
      })
    );
  } else {
    //send data (service, option) to reducer to save services list
    dispatch(
      saveFeedback({
        serviceId: serviceId,
        rate: option.name,
      })
    );
    if (
      pageComponents?.length === 1 &&
      pageComponents[0]?.attrs?.service?.length === 1
    ) {
      dispatch(nextPage());
    }
  }
};

export const selectMark = (mark) => (dispatch, getState) => {
  const { markpage } = getState();
};

export const closeMarkpage = () => ({
  type: types.CLOSE_MARKPAGE,
});

export const saveFeedback = (data) => ({
  type: types.SAVE_FEEDBACK,
  data,
});

const showMarkpage = (data) => ({
  type: types.SHOW_MARKPAGE,
  data,
});

export const isSliMutliService = (data) => ({
  type: types.IS_SLI_MULTI_SERVICE,
  data,
});

export const resetCurrentFeedbackScore = (data) => ({
  type: types.RESET_CURRENT_FEEDBACK_SCORE,
  data,
});

export const setCurrentPage = (data) => ({
  type: types.SET_CURRENT_PAGE,
  data,
});

export const fetchIdentification =
  (identificationArray) => async (dispatch, getState) => {
    // console.log(identificationArray)
    // const { formValues = {}, uid = '' } = getState()
    // const reqData = generateIdentificationData({identificationArray, formValues})
    // if (!isEmpty(reqData)) {
    //   const pickedIdentificationValues = pick(formValues.customer_data, identificationArray)
    //   dispatch(fetchIdentificationStarted())
    //   if (!isEmpty(pickedIdentificationValues)) {
    //   After api
    //   dispatch(fetchIdentificationSuccess({
    //     status: false,
    //     customer: {
    //       "id": 1,
    //       "full_name": "",
    //       "phone_number": "",
    //       "email": "",
    //       "gender": ""
    //     }
    //   }))
    //   try {
    //     const res = await checkIdentification(reqData, uid)
    //     dispatch(fetchIdentificationSuccess(res)
    //     return res
    //   } catch (err) {
    //     console.log(err)
    //     dispatch(fetchIdentificationFailure(err))
    //     return err
    //   }
    // }
  };

export const fetchIdentificationStarted = () => ({
  type: types.FETCH_WIDGET_JSON_STARTED,
});

export const fetchIdentificationSuccess = (data) => ({
  type: types.FETCH_IDENTIFICATION_SUCCESS,
  data,
});

export const fetchIdentificationFailure = (data) => ({
  type: types.FETCH_IDENTIFICATION_FAILURE,
  data,
});

export const fetchSendCollectedFeedback = () => (dispatch, getState) => {
  const {
    uid,
    formValues,
    feedbackArray,
    sessionId,
    selectedLanguage,
    widgetJSON,
  } = getState();
  const { data = {} } = widgetJSON;
  //My changes
  //    dispatch(fetchSendCollectedFeedbackStarted())
  let newFeedbackArray = [];
  feedbackArray.map((item) => {
    item.service_id = item.serviceId;
    const newItem = omit(item, ["serviceId"]);
    newFeedbackArray.push(newItem);
  });

  const customFieldsItems = { ...formValues.custom_field_feedback_component };
  const omittedFormValues = omit(formValues, [
    "custom_field_feedback_component",
  ]);

  const collectedData = {
    ...omittedFormValues,
    ...customFieldsItems,
    sessionId,
    language: selectedLanguage,
    feedbacks: newFeedbackArray,
  };

  const reqData = removeSli({ feedbackArray, collectedData });

  if (appParamater.name === "ibar" && reqData?.customer_data?.ibar_name) {
    reqData.customer_data.full_name = `${reqData.customer_data.ibar_name} ${reqData.customer_data.ibar_lastname}`;
    delete reqData.customer_data.ibar_name;
    delete reqData.customer_data.ibar_lastname;
  }

  dispatch(fetchSendCollectedFeedbackStarted());
  sendCollectedFeedback({ uid, data: reqData })
    .then((res) => {
      dispatch(fetchSendCollectedFeedbackSuccess());
      // dispatch({ type: types.NEXT_PAGE })
      dispatch(handleNextPage());
      if (!data.general_settings.is_kiosk_mode) {
        handleSaveCookies(getState());
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch(fetchSendCollectedFeedbackFailure(err));
      dispatch(handleNextPage());
    });

  console.log(JSON.stringify(collectedData));
  console.log(collectedData);
};

const handleSaveCookies = (state) => {
  let {
    sessionId,
    uid,
    currentFeedbackScore,
    selectedLanguage,
    sessions = {},
    pages,
    currentPage,
    tempFeedbackScore,
    feedbackArray,
    condition,
  } = state;
  const rate = generateFinalPage({ feedbackArray });

  if (tempFeedbackScore > 0 && currentFeedbackScore) {
    currentFeedbackScore += tempFeedbackScore;
  } else if (tempFeedbackScore > 0 && currentFeedbackScore === null) {
    currentFeedbackScore = tempFeedbackScore;
  }

  const newSessions = {
    ...sessions,
    [uid]: {
      sessionId,
      feedbackScore: currentFeedbackScore,
      selectedLanguage,
      rate,
    },
  };

  Cookies.set("sessions", JSON.stringify(newSessions));
};

const removeSli = ({ feedbackArray, collectedData }) => {
  const serviceIds = feedbackArray.map((item) => item.serviceId);
  const newData = omit(collectedData, serviceIds);
  return newData;
};

const fetchSendCollectedFeedbackStarted = () => ({
  type: types.FETCH_SEND_COLLECTED_FEEDBACK_STARTED,
});

const fetchSendCollectedFeedbackSuccess = () => ({
  type: types.FETCH_SEND_COLLECTED_FEEDBACK_SUCCESS,
});

const fetchSendCollectedFeedbackFailure = (data) => ({
  type: types.FETCH_SEND_COLLECTED_FEEDBACK_FAILURE,
  data,
});

export const resetWidget = () => (dispatch, getState) => {
  const { uid } = getState();

  dispatch({
    type: types.RESET_WIDGET,
  });

  dispatch(fetchWidgetJSON());
};

export const addToCustomFormValues = (data) => ({
  type: types.ADD_TO_CUSTOM_FORM_VALUES,
  data,
});

export const updateCondition = () => ({
  type: types.UPDATE_CONDITION,
});

export const saveRenderedComponents = (data) => ({
  type: types.SAVE_RENDERED_COMPONENTS,
  data,
});

// const resetWidgetTimer = debounce(()=> {
//   alert('hi')
// }, 1000)

// const debounce = (func, wait) => {
//   let timeout;

//   return function executedFunction(...args) {
//     const later = () => {
//       clearTimeout(timeout);
//       func(...args);
//     };

//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// };

export const setButtonDesible = (data) => ({
  type: types.SET_BUTTONS_DISABLE,
  data,
});

export const setScroll = (data) => ({
  type: types.SET_SCROLL,
  data,
});
